import { hubbleAPI } from './url'
const resource = hubbleAPI + 'secure/public'
export default ($axios) => ({
  validateOsm(osmDTO, cartID = '') {
    return $axios.post(`${resource}/validate/osm/${cartID}`, osmDTO)
  },
  getOsmStatus(osmOrderId, cartID = '') {
    return $axios.get(`${resource}/osm/status/${osmOrderId}/${cartID}`)
  },
  saveOsmDetails(osmStatus, osmOrderId, cartID) {
    return $axios.post(`${resource}/ct/add-osm-details/${osmStatus}/${osmOrderId}/${cartID}`)
  }
})
